const PREFIX = 'OPEN_PLATFORM_MY_APP_';

export const OPEN_PLATFORM_MY_APP_PAGE_REQUEST = `${PREFIX}PAGE_REQUEST`;

export const OPEN_PLATFORM_MY_APP_LIST_REQUEST = `${PREFIX}LIST_REQUEST`;

export const OPEN_PLATFORM_MY_APP_ON_CLICK_REMOVE_APP = `${PREFIX}ON_CLICK_REMOVE_APP`;

export const OPEN_PLATFORM_MY_APP_ON_CONFIRM_REMOVE_APP = `${PREFIX}ON_CONFIRM_REMOVE_APP`;

export const OPEN_PLATFORM_MY_APP_ON_CHANGE_FIELD = `${PREFIX}ON_CHANGE_FIELD`;

export const OPEN_PLATFORM_MY_APP_ON_CANCEL_REMOVE_APP = `${PREFIX}ON_CANCEL_REMOVE_APP`;

export const OPEN_PLATFORM_MY_APP_SET_APPS = `${PREFIX}SET_APPS`;

export const OPEN_PLATFORM_MY_APP_SET_REMOVED_APP = `${PREFIX}SET_REMOVED_APP`;

export const OPEN_PLATFORM_MY_APP_SHOW_CONFIRM_REMOVE_MODAL = `${PREFIX}SHOW_CONFIRM_REMOVE_MODAL`;

export const OPEN_PLATFORM_MY_APP_HIDE_CONFIRM_REMOVE_MODAL = `${PREFIX}HIDE_CONFIRM_REMOVE_MODAL`;

export const OPEN_PLATFORM_MY_APP_SET_SUBMIT = `${PREFIX}SUBMITTING`;

export const OPEN_PLATFORM_MY_APP_SET_BUSINESS = `${PREFIX}SET_BUSINESS`;
